module.exports = __webpack_public_path__ + "img/aliens-nose.0329361c.png";